function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import { isEmailValid } from "@limitless/customer/utils";
import { isFieldEmpty } from "@limitless/common/utils";
import CheckTextField from "./CheckTextField";
const EmailTextField = ({
  check,
  onChange,
  ...rest
}) => {
  const {
    isInvalid = false
  } = check;
  const validateEmailAndUpdate = newValue => {
    let isInvalid = false;
    if (isFieldEmpty(newValue) || !isEmailValid(newValue)) {
      isInvalid = true;
    }
    onChange(newValue, isInvalid);
  };
  return /*#__PURE__*/React.createElement(CheckTextField, _extends({}, rest, {
    check: check,
    onChange: validateEmailAndUpdate,
    helperText: isInvalid ? "Must be valid email address" : null,
    placeholder: "email@address.com"
  }));
};
export default EmailTextField;
EmailTextField.propTypes = {
  check: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};